import type { Product } from 'reactApp/types/Billing';
import { getMonthProductPrice } from 'reactApp/utils/priceHelpers';

export const economy = (monthProduct: Product, yearProduct: Product) => {
    const discountPeriodCount = monthProduct.discountPeriodCount || 0;
    const monthProductPrice = getMonthProductPrice(monthProduct);

    if (!yearProduct) {
        return;
    }

    return yearProduct.discountPrice
        ? discountPeriodCount * monthProductPrice +
              (12 - discountPeriodCount) * getMonthProductPrice(monthProduct, false) -
              yearProduct.discountPrice
        : 0;
};
